import CloseModal from "@assets/images/CloseModal.svg";
import InvoiceIcon from "@assets/images/invoices.svg";
import SearchIconDark from "@assets/images/search-dark.svg";
import Search from "@assets/images/Search-new.svg";
import ShippingIcon from "@assets/images/shipping-icon.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from "@material-ui/core";
import FormField from "@saleor/components/FormField/FormField";
import MyTypography from "@saleor/components/MyTypography";
import ModalTransportZone from "@saleor/createOrChangeNotRefContract/components/ModalAddress/ModalTransportZone";
import { isDirtyField } from "@saleor/createOrChangeNotRefContract/utils";
import { makeStyles } from "@saleor/macaw-ui";
import { FormikProps } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import InlineSVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl/lib";

import ModalSearchShipTo from "./ModalSearchShipTo";
import useOneTimeFormiks from "./useOnetimeFormiks";
import useOneTimeForms from "./useOneTimeForms";
export interface ModalOneTimeFormsProps {
  onClose: () => void;
  visible: boolean;
  formikHeader?: FormikProps<any>;
  onSearchSubmit?: (name, Deletename, value) => void;
  onSubmit?: (name, Deletename, formikValue) => void;
  formType?: string;
  modalShipToSearch?: (boolean) => void;
  otcInitialValue?: any;
  searchInitialValue?: string;
  isChangeFlow?: boolean;
  currentAction?: "none" | "add" | "split" | "edit";
}

export const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "20px 24px 10px",
      display: "flex"
    },
    dialogTitleWrap: {
      height: "40px",
      display: " flex",
      alignItems: "center",
      lineHeight: "normal",
      marginBottom: "24px",
      marginTop: "0px",
      marginLeft: "-22px"
    },
    mainTitle: {
      fontSize: "2rem",
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400,
      fontSize: "1.6rem"
    },
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 580,
        width: "100%",
        borderRadius: 12,
        border: "16px solid #FFFFFF"
      },
      "& .MuiDialogTitle-root": {
        paddingTop: "3px",
        marginBottom: "-20px",
        marginRight: "-22px"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 7
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    detailTitle: {
      fontWeight: "bold",
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal"
      }
    },
    dialogContent: {
      width: "100%",
      background: "#F2FAFB",
      maxHeight: "calc(100% - 64px)",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    formControlLabel: {
      marginBottom: "2.5rem"
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    nameHead: {
      marginTop: 0,
      marginLeft: "12px",
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    },
    rowFlex: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      backgroundColor: "white",
      justifyContent: "center",
      border: "1px solid black",
      borderRadius: "4px",
      paddingTop: "10px",
      paddingBottom: "10px",
      cursor: "pointer",
      marginBottom: "16px",
      height: "40px"
    },
    addressSubHeader: {
      marginLeft: "7px",
      marginTop: "25px",
      color: "#009FB8"
    },
    addressButton: {
      marginLeft: "7px",
      width: "280px",
      height: "30px",
      fontSize: "14px",
      marginRight: "159px"
    },
    searchIcon: {
      height: "20px",
      width: "20px"
    }
  }),
  { name: "ModalAddress" }
);

const ModalOneTimeForms: React.FC<ModalOneTimeFormsProps> = props => {
  const {
    visible,
    onClose,
    formikHeader,
    onSearchSubmit,
    onSubmit,
    formType,
    otcInitialValue = null,
    searchInitialValue = null,
    isChangeFlow,
    currentAction
  } = props;
  const [submitted, setSubmitted] = useState<boolean>(false);
  const { otcBillTo, otcShipTo } = useOneTimeFormiks(
    otcInitialValue,
    submitted,
    formikHeader?.values?.soldToCode
  );
  const localFormik: FormikProps<any> =
    formType === "shipTo" ? otcShipTo : otcBillTo;
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const classes = useStyles();
  const [visibleTransportZone, setVisibleTransportZone] = useState(false);
  const { formOneTimeShipTo, formOneTimeBillTo } = useOneTimeForms(localFormik);
  const [searchVisible, setSearchVisible] = useState<boolean>(
    isChangeFlow && formType === "shipTo" && currentAction !== "add"
  );

  const parentOtcFormikName =
    "otc" + formType[0].toUpperCase() + formType.substring(1);

  useEffect(() => {
    if (isDirtyField(localFormik, "countryCode")) {
      localFormik.setValues(prev => ({
        ...prev,
        city: "",
        district: "",
        subDistrict: "",
        postalCode: "",
        street1: "",
        street2: "",
        transportZoneCode: "",
        transportZoneName: ""
      }));
    }
  }, [localFormik.values.countryName]);

  useEffect(() => {
    if (isDirtyField(localFormik, "city")) {
      localFormik.setValues(prev => ({
        ...prev,
        district: "",
        subDistrict: "",
        postalCode: ""
      }));
    }
  }, [localFormik.values.city]);

  useEffect(() => {
    if (isDirtyField(localFormik, "district")) {
      localFormik.setValues(prev => ({
        ...prev,
        subDistrict: "",
        postalCode: ""
      }));
    }
  }, [localFormik.values.district]);

  const selectedForm =
    formType === "shipTo"
      ? formOneTimeShipTo
      : formType === "billTo"
      ? formOneTimeBillTo
      : null;

  const formIconHead = useMemo(() => {
    switch (formType) {
      case "billTo":
        return {
          iconHead: InvoiceIcon,
          nameHead: "Bill-to Party"
        };
      case "shipTo":
        return {
          iconHead: ShippingIcon,
          nameHead: "Ship-to Party"
        };
    }
  }, [formType]);

  const handleSubmit = async () => {
    setSubmitted(true);
    const isValid = await localFormik.validateForm();
    if (localFormik.values.countryCode !== "TH") {
      delete isValid?.branchId;
      delete isValid?.taxId;
    }

    if (isValid && Object.keys(isValid).length === 0) {
      onSubmit(parentOtcFormikName, formType, localFormik.values);
      onClose();
    }
  };
  const handleClickTransportZone = () => {
    setVisibleTransportZone(true);
  };
  const handleClickVatInfo = () => {
    window.open(
      "https://vsinter.rd.go.th/rd-webcontent-web/#/vatsearch",
      "_blank",
      "noopener"
    );
  };
  if (searchVisible) {
    return (
      <ModalSearchShipTo
        open={searchVisible}
        formik={formikHeader}
        initialValue={searchInitialValue}
        handleSubmit={value => {
          onSearchSubmit(
            formType,
            "otc" + formType[0].toUpperCase() + formType.substring(1),
            value
          );
          onClose();
        }}
        onClose={() => {
          setSearchVisible(false);
          onClose();
        }}
        onBack={() => setSearchVisible(false)}
        isChangeFlow={isChangeFlow}
        currentAction={currentAction}
      />
    );
  }
  return (
    <Dialog
      open={visible}
      className={classes.root}
      data-testid="modalOneTimeForms"
    >
      <DialogTitle className={classes.dialogTitle}>
        <div className={classes.dialogTitleWrap}>
          <InlineSVG src={formIconHead?.iconHead} />
          <MyTypography
            variant={"h6"}
            className={classes.nameHead}
            data-testid="modal-onetime-title"
          >
            {formIconHead?.nameHead}
          </MyTypography>

          <InlineSVG
            id="closeButton"
            onClick={onClose}
            src={CloseModal}
            style={{
              height: "24px",
              width: "24px",
              cursor: "pointer",
              marginLeft: formType === "billTo" ? "367px" : "343px"
            }}
          />
        </div>
      </DialogTitle>
      {formType === "shipTo" ? (
        <Button
          id="searchShipTo"
          className={classes.rowFlex}
          onClick={() => setSearchVisible(true)}
        >
          <InlineSVG src={SearchIconDark} fill="#fff" />
          <MyTypography variant={"subtitle3"}>ค้นหา Ship-to อื่น</MyTypography>
        </Button>
      ) : null}
      <DialogContent dividers={false} className={classes.dialogContent}>
        <Grid container spacing={2} justify="space-between">
          {selectedForm.map((field, index) => {
            if (!field?.hideField) {
              switch (field.type) {
                case "Headers":
                  return (
                    <Grid key={index} item md={12}>
                      <MyTypography
                        variant="h7"
                        className={classes.addressSubHeader}
                      >
                        {field.title}
                      </MyTypography>
                    </Grid>
                  );
                case "Button":
                  return (
                    <Button
                      key={index}
                      id={field.title}
                      variant="contained"
                      color={"secondary"}
                      className={classes.addressButton}
                      startIcon={
                        <InlineSVG
                          src={Search}
                          className={classes.searchIcon}
                        />
                      }
                      onClick={handleClickVatInfo}
                    >
                      {field.title}
                    </Button>
                  );

                case "transportationZone":
                  return (
                    <Grid key={index} item md={6}>
                      <p
                        style={{
                          fontWeight: 600,
                          marginBottom: "-2px",
                          marginTop: "9px"
                        }}
                      >
                        {field.title}
                      </p>

                      <Button
                        id="transportationZoneButton"
                        data-testid="transportationZoneButton"
                        onClick={handleClickTransportZone}
                        className={classes.rowFlex}
                        style={{
                          marginBottom: 0,
                          height: "36px",
                          border: "1px solid #CCCCCC",
                          fontSize: "14px",
                          fontWeight: "normal",
                          alignItems: "center",
                          cursor: "pointer"
                        }}
                      >
                        {localFormik.values?.transportZoneCode !== "" ? (
                          <span
                            style={{ color: "#222222", paddingRight: "0px" }}
                          >
                            {localFormik?.values?.transportZoneCode} -
                            {localFormik?.values?.transportZoneName}
                          </span>
                        ) : (
                          <span
                            style={{ color: "#999999", paddingRight: "0px" }}
                          >
                            เลือก Transportation Zone
                          </span>
                        )}
                        <Button
                          ref={anchorRef}
                          id="searchIconButton"
                          onClick={() => null}
                          style={{
                            marginLeft: "-36px",
                            alignSelf: "center"
                          }}
                        >
                          <InlineSVG
                            src={SearchIconDark}
                            width={24}
                            height={24}
                            style={{ marginRight: "-26px" }}
                          />
                        </Button>
                      </Button>
                    </Grid>
                  );

                default:
                  return (
                    <FormField
                      key={index}
                      gridStyle={{ alignSelf: "flex-end" }}
                      {...field}
                      value={localFormik.values[field.name]}
                      handleChange={localFormik.handleChange}
                      name={field.name || "defaultName"}
                      error={localFormik.errors[field.name]}
                      id={field.name}
                    />
                  );
              }
            }
          })}
        </Grid>
      </DialogContent>
      <ModalTransportZone
        visible={visibleTransportZone}
        onClose={() => {
          setVisibleTransportZone(false);
        }}
        formik={localFormik}
        anchorRef={anchorRef}
      />
      <DialogActions>
        <Button
          id="closeButton"
          data-testid="closeButton"
          variant={"outlined"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={onClose}
        >
          <FormattedMessage defaultMessage={"ยกเลิก"} />
        </Button>
        <Button
          id="submitButton"
          data-testid="submitButton"
          variant={"contained"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={handleSubmit}
        >
          <FormattedMessage defaultMessage={"ตกลง"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ModalOneTimeForms.displayName = "ModalOneTimeForms";
export default ModalOneTimeForms;
